export default __webpack_public_path__ + "static/banner-media-release-28d-travel-insurance-18d065cbb15cc934f7eaa7b665e1d3c9.jpg";